var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-radio-group',{on:{"change":_vm.changeData},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},[_c('el-radio',{attrs:{"label":"91"}},[_vm._v("开启对外展示")]),_c('el-radio',{attrs:{"label":"92"}},[_vm._v("关闭对外展示")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }